/* eslint-disable import/no-unresolved */
import {
  Modal,
  Box,
  Typography,
  Slide,
  Backdrop,
  Stack,
  Button,
  IconButton,
} from '@mui/material';

const boxStyle = {
  position: 'absolute',
  height: '400px',
  width: '500px',
  backgroundColor: '#fff',
  borderRadius: '15px',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  margin: 'auto',
  textAlign: 'center',
  py: 4,
  px: 4,
};

interface SaveChangeProps {
  show: boolean;
  handleModalClose: () => void;
  handleConfirm: () => void;
  partialPayment: boolean;
}
const ConfirmPaymentSubmission: React.FC<SaveChangeProps> = ({
  show,
  handleModalClose,
  handleConfirm,
  partialPayment,
}) => (
  <div>
    <Modal
      open={show}
      onClose={handleModalClose}
      aria-labelledby="logout-modal-title"
      aria-describedby="logout-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Slide direction="up" in={show} mountOnEnter unmountOnExit>
        <Box sx={boxStyle}>
          <Box sx={{ textAlign: 'left', marginBottom: 6 }}>
            <IconButton
              onClick={handleModalClose}
              sx={{
                width: '92px',
                height: '40px',
                borderRadius: '90px',
                p: '12px 16px',
                position: 'absolute',
                left: 0,
                top: '10px',
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  marginLeft: 1,
                  fontFamily: 'Montserrat',
                  color: (theme) => theme.palette.primary.main,
                }}
              >
                Close
              </Typography>
            </IconButton>
          </Box>
          <Typography
            sx={{ fontSize: '20px', fontWeight: 700, color: '#0043B9' }}
          >
            Confirm?
          </Typography>

          <Typography sx={{ fontSize: '15px', color: '#252525', marginTop: 2 }}>
            {partialPayment
              ? 'You are about to permanently submit a sale on credit'
              : 'You are about to permanently submit a sales invoice.'}
          </Typography>

          <Stack mt={10} width="90%" mx="auto" spacing={2}>
            <Button
              variant="contained"
              onClick={() => handleConfirm()}
              disableElevation
            >
              Submit
            </Button>
            <Button
              onClick={() => handleModalClose()}
              variant="outlined"
              sx={{
                backgroundColor: 'transparent',
                border: '1px solid #C1C7D0',
                color: '#252525',
                '&:hover': {
                  backgroundColor: '#C1C7D0',
                  border: '1px solid transparent',
                },
              }}
            >
              Go back
            </Button>
          </Stack>
        </Box>
      </Slide>
    </Modal>
  </div>
);
export default ConfirmPaymentSubmission;
